// @debt Remove comments and fix file after release. Way too many errors to fix pre-release.
// There are global variables, name shadowing, wrong scopes, mutation and many more errors.

/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';
import Request, { ApiMode } from '../../utils/request';

const NAME = 'Map';

const COURTS_ZOOM_LEVEL = 12;
const DEFAULT_ZOOM_LEVEL = 10;

class Map extends BaseComponent {
	constructor(element) {
		super(element);
		this._element = element;
		this.parent = element.parentElement;
		this.mapWrapper = SelectorEngine.findOne('.lta__map');
		this.mapType = Manipulator.getDataAttribute(this.mapWrapper, 'type');
		this.showMarkers = Manipulator.getDataAttribute(this.mapWrapper, 'showmarkers');
		this.hasScrollBtn = SelectorEngine.findOne('.js-search-area', this.mapWrapper);
		this.card;
		this.container;
		this.endpoint = '';
		this.map = {};
		this.iter = 0;
		this.position = {
			latitude: LTA_DEFAULT_LOCATION.latitude,
			longitude: LTA_DEFAULT_LOCATION.longitude
		};
		const isCourtMap = this.mapType === 'find-courts';
		const ZOOM_LEVEL = isCourtMap ? COURTS_ZOOM_LEVEL : DEFAULT_ZOOM_LEVEL;
		this.options = {
			draggable: true,
			restriction: {
				latLngBounds: { north: 90, south: -90, west: -180, east: 180 },
				strictBounds: false
			},
			zoom: ZOOM_LEVEL,
			gestureHandling: 'cooperative'
			//disableDefaultUI: true
		};
		this.key = 'AIzaSyDyzGpEphEVl2MRq76Y6Y9VL32JGQr2heg';
		this.isMobile = window.matchMedia('(max-width: 1199.99px)').matches;
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		this.getPositionParamsFromQueryString();
		if (this.hasScrollBtn) {
			const div = document.createElement('DIV');
			this.mapWrapper.append(div);
			this.mapWrapper = div;
		}
		// Create Map

		this.createMap();
		this.endpoint = Manipulator.getDataAttribute(this.mapWrapper, 'endpoint');

		if (this.mapType === 'find-a-coach') {
			this.card = SelectorEngine.findOne('.lta-mapView .lta-card--multiple');
			this.container = SelectorEngine.findOne('.lta-mapView  .lta-card-container');
			this.locationInput = SelectorEngine.findOne('.js-location-search-field-input');

			// If parameters in Query List the location will be override
			//this.getPositionParamsFromQueryString();
			this.fetchCoachLocationData();

			this.expandHandler();
		} else if (this.mapType === 'find-courts') {
			this.renderPins();
			this.mapScrollHandler();
		} else if (this.mapType === 'multiple-sessions') {
			this.multipleSessions();
		} else {
			// map.Type == 'find-a-court'
			this.renderCourtLocations();

			// Use position to render view list
		}
	}

	getPositionParamsFromQueryString() {
		const queryString = new URLSearchParams(location.search);
		if (queryString.get('latitude')) {
			this.position.latitude = queryString.get('latitude');
			this.position.longitude = queryString.get('longitude');
			return true;
		}
		return false;
	}

	fetchCoachLocationData() {
		let queryString = location.search.split('?'),
			filters = '';

		queryString.forEach((e) => {
			let newS = e.split('&');

			newS.forEach((x) => {
				if (x.length && !x.includes('latitude') && !x.includes('longitude') && !x.includes('sort')) filters += '&' + x;
			});
		});

		const url = `${this.endpoint}?latitude=${this.position.latitude}&longitude=${this.position.longitude}${filters}`,
			currentLocation = window.location.origin + window.location.pathname; // Remove window.location.pathname if not needed in the URL

		Request.get(url, false, { req: { apiMode: ApiMode.LtaError } })
			.then((response) => {
				this.hideLoader();

				if (response.locations.length > 0 && this.showMarkers == true && this.mapType == 'find-a-coach') {
					// not ideal but an else if for other maps types is the only solution here as far as I can see
					SelectorEngine.find('.js-lta-map-court-count').forEach((e) => {
						e.innerHTML = response.locations.length;
					});

					const base = window.location.origin,
						activeIcon = {
							url: base + '/static/images/spotlight-blue-1.png',
							scaledSize: new google.maps.Size(27, 43)
						},
						normalIcon = {
							url: base + '/static/images/spotlight-red.png',
							scaledSize: new google.maps.Size(27, 43)
						};

					let markers = [],
						bounds = new google.maps.LatLngBounds();

					// Clear all set marker icons
					const clearMarkerIcons = () => {
						for (var i = 0; i < markers.length; i++) {
							markers[i].setIcon(normalIcon);
						}
					};

					response.locations.forEach((marker, i) => {
						const pin = new google.maps.Marker({
							position: new google.maps.LatLng(marker.Latitude, marker.Longitude),
							map: this.map,
							optimized: false,
							icon: normalIcon
						});
						markers.push(pin);
						bounds.extend(pin.getPosition());

						google.maps.event.addListener(pin, 'click', () => {
							clearMarkerIcons();
							pin.setIcon(activeIcon);
							Request.get(
								`/api/coach/CoachesForVenue/?latitude=${marker.Latitude}&longitude=${marker.Longitude}&venueId=${marker.Id}${filters}`
							)
								.then((response) => {
									const card = this.card,
										dummy = SelectorEngine.findOne('.lta-card--multiple__dummy'),
										venue = SelectorEngine.findOne('.lta-card--multiple .js-lta-venue-name'),
										coachN = SelectorEngine.findOne('.lta-card--multiple .js-lta-coach-count');

									// Clear previous coaches.
									let dummies = SelectorEngine.find('.lta-card--multiple__dummy');
									dummies.forEach((e, i) => {
										if (i > 0) {
											e.remove();
										}
									});

									if (response.VenueName) {
										venue.innerHTML = response.VenueName;
									} else {
										venue.innerHTML = 'Unknown Venue Name';
									}

									coachN.innerHTML = response.Coaches.length;

									if (response.Coaches.length > 3) {
										let expand = SelectorEngine.findOne('.js-lta-map-expand', card);
										expand.classList.remove('u-hidden');
									}

									response.Coaches.forEach((coach, i) => {
										let card;
										if (i == 0) {
											card = dummy;
										} else {
											card = dummy.cloneNode(true);
											this.container.append(card);
										}

										// For view more option
										if (i > 2) {
											card.classList.add('u-hidden');
										}

										let name = SelectorEngine.findOne('.lta-card-coach--name', card),
											level = SelectorEngine.findOne('.p-find-coach-level', card),
											qualification = SelectorEngine.findOne('.p-find-coach-qualification', card),
											link = SelectorEngine.findOne('.lta-card-coach-link', card);

										let span = SelectorEngine.findOne('span', qualification);

										if (coach.QualificationLevel) {
											level.setAttribute('data-level', coach.QualificationLevel);
											span.innerHTML = 'Level ' + coach.QualificationLevel;
										} else {
											span.innerHTML = 'Non LTA Qualification';
										}

										// Constructing the coach URL

										let urlStr = currentLocation + '/coach-details/'; //[Coach ID]/[URL encoded coach name]/';

										if (coach.Id) {
											urlStr += coach.Id + '/' + encodeURI(coach.Name);
											link.setAttribute('href', urlStr);
										} else {
											link.classList.add('u-hidden');
										}

										name.innerHTML = coach.Name;
									});
									card.classList.remove('u-hidden');
								})
								.catch((error) => {
									console.log(error.message);
								});
						});

						this.map.fitBounds(bounds, 0);
						this.map.setCenter(markers[0].getPosition());

						setTimeout(() => {
							this.map.setOptions(this.options);
						}, 1000);
					});
				}

				return '';
			})
			.catch((error) => {
				this.parent.classList.add('hasError');
				Manipulator.setDataAttribute(this.parent, 'error', error.message ? error.message : 'Unknown');
			});
	}

	renderCourtLocations() {
		this.hideLoader();

		const dummyCard = SelectorEngine.findOne('.lta-card-court--dummy'),
			currentLocation = window.location.origin + window.location.pathname,
			base = window.location.origin,
			activeIcon = {
				url: base + '/static/images/spotlight-blue-1.png',
				scaledSize: new google.maps.Size(27, 43)
			},
			normalIcon = {
				url: base + '/static/images/spotlight-red.png',
				scaledSize: new google.maps.Size(27, 43)
			};

		let markers = [],
			bounds = new google.maps.LatLngBounds();

		// Clear all set marker icons
		const clearMarkerIcons = () => {
			for (var i = 0; i < markers.length; i++) {
				markers[i].setIcon(normalIcon);
			}
		};

		LTA_COURT_DATA.forEach((marker, i) => {
			const pin = new google.maps.Marker({
				position: new google.maps.LatLng(marker.address.latitude, marker.address.longitude),
				map: this.map,
				optimized: false,
				icon: normalIcon
			});
			markers.push(pin);

			bounds.extend(pin.getPosition());

			google.maps.event.addListener(pin, 'click', () => {
				clearMarkerIcons();
				pin.setIcon(activeIcon);
				dummyCard.classList.add('no-opacity');

				let title = SelectorEngine.findOne('.lta-card-title', dummyCard),
					tag = SelectorEngine.findOne('.lta-tag', dummyCard),
					address = SelectorEngine.findOne('.lta-card-address span', dummyCard),
					courts = SelectorEngine.findOne('.lta-card-courts', dummyCard),
					distance = SelectorEngine.findOne('.lta-card-distance', dummyCard),
					link = SelectorEngine.findOne('.lta-card-courtLink', dummyCard),
					booking = SelectorEngine.findOne('.lta-card-courtBooking', dummyCard);

				title.innerHTML = marker.name;
				if (!marker.ltaRegistered) {
					tag.classList.add('u-hidden');
				} else {
					tag.classList.remove('u-hidden');
				}

				if (marker.distanceAway) {
					SelectorEngine.findOne('span', distance).innerHTML =
						parseFloat(marker.distanceAway).toFixed(2) + ' miles away';
					if (distance.classList.contains('u-hidden')) distance.classList.remove('u-hidden');
				} else {
					distance.classList.add('u-hidden');
				}

				// Construct Courts
				let str = '';

				for (var [type, t] of Object.entries(marker.courts)) {
					str += type + ' x' + t.count + ', ';
				}
				SelectorEngine.findOne('span', courts).innerHTML = str;

				// Construct Address String

				let html = marker.address.street;
				if (marker.address.state) {
					html += ', ' + marker.address.state;
				}
				if (marker.address.city) {
					html += ', ' + marker.address.city;
				}
				if (marker.address.postalCode) {
					html += ', ' + marker.address.postalCode;
				}
				address.innerHTML = html;

				link.href = currentLocation + 'Venue/?VenueId=' + marker.id;
				Manipulator.setDataAttribute(link, 'aria-label', 'View ' + marker.name + ' details');
				if (marker.bookingLink.length) {
					booking.href = marker.bookingLink;
					booking.classList.remove('u-hidden');
				} else {
					booking.classList.add('u-hidden');
				}
				Manipulator.setDataAttribute(booking, 'aria-label', 'Make a booking with ' + marker.name);

				if (dummyCard.classList.contains('u-hidden')) {
					dummyCard.classList.remove('u-hidden');
				}
				dummyCard.classList.remove('no-opacity');
			});
		});
		this.map.setCenter(markers[0].getPosition());
		this.map.fitBounds(bounds, 0);

		setTimeout(() => {
			this.map.setOptions(this.options);
		}, 1000);
	}

	mapScrollHandler() {
		EventHandler.on(this.hasScrollBtn, 'click', () => {
			const newCoord = this.map.getCenter();

			// Doing it this way to keep all the other parameters and filters applied as it is
			let url = new URL(window.location);
			let params = new URLSearchParams(url.search);

			params.set('latitude', newCoord.lat());
			params.set('longitude', newCoord.lng());

			const GEOCODING =
				'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
				newCoord.lat() +
				',' +
				newCoord.lng() +
				'&result_type=locality&language=en&key=' +
				this.key;

			let locationName = '';

			Request.get(GEOCODING, false, { local: false })
				.then((response) => {
					response.results.forEach((result, i) => {
						if (i == 0) {
							locationName = result.formatted_address;
							params.set('location', locationName);
							window.location = window.location.origin + window.location.pathname + '?' + params.toString();
						} else {
							return '';
						}
					});
				})
				.catch((error) => {
					alert(error);
				});
		});
		google.maps.event.addListener(this.map, 'dragend', () => {
			this.hasScrollBtn.classList.add('active');
		});
	}

	renderPins() {
		this.hideLoader();

		const currentLocation = window.location.origin + window.location.pathname,
			base = window.location.origin,
			activeIcon = {
				url: base + '/static/images/spotlight-blue-1.png',
				scaledSize: new google.maps.Size(27, 43)
			},
			normalIcon = {
				url: base + '/static/images/spotlight-red.png',
				scaledSize: new google.maps.Size(27, 43)
			};

		let markers = [],
			bounds = new google.maps.LatLngBounds();

		// Clear all set marker icons

		const clearMarkerIcons = () => {
			for (var i = 0; i < markers.length; i++) {
				markers[i].setIcon(normalIcon);
			}
		};

		let currentInfo = undefined;

		const courtCards = SelectorEngine.find('.lta-mapview-results .lta-card-court-booking');
		const scrollWrapper = SelectorEngine.findOne('.lta-mapview-scroll-wrapper');

		if (LTA_COURT_LIST.length > 0)
			LTA_COURT_LIST.forEach((marker, i) => {
				const pin = new google.maps.Marker({
					icon: normalIcon,
					map: this.map,
					optimized: false,
					position: new google.maps.LatLng(marker.location.geo.latitude, marker.location.geo.longitude),
					title: marker?.location?.name
				});
				const currentMap = this.map;

				markers.push(pin);

				bounds.extend(pin.getPosition());
				const url = marker.location?.image?.[0]?.url;
				const href = SelectorEngine.findOne('.lta-card-title a', courtCards[i]).getAttribute('href');

				let contentString = `<a id="bodyContent" href="${href}" target="_blank">
					${url && `<img src="${decodeURIComponent(url)}" alt="${marker.location.name} Image"/>`}
					  <div id="content" class="u-p-2 u-block">
						<h1 class="u-caption1 u-mb-0" >${marker.location.name}</h1>
						${marker.distanceAway && `<p class="u-body2">${Number(marker.distanceAway.toFixed(1))} miles away</p>`}
					  </div>
					</a>`;

				if(href === '' || href === '#') {
					contentString = `<span id="bodyContent">
					${url && `<img src="${decodeURIComponent(url)}" alt="${marker.location.name} Image"/>`}
					  <div id="content" class="u-p-2 u-block">
						<h1 class="u-caption1 u-mb-0" >${marker.location.name}</h1>
						${marker.distanceAway && `<p class="u-body2">${Number(marker.distanceAway.toFixed(1))} miles away</p>`}
					  </div>
					</span>`;
				} 

				const infowindow = new google.maps.InfoWindow({
					content: contentString,
					maxWidth: 276,
					ariaLabel: `${marker.location.name} map information window`
				});

				this.map.addListener('click', () => {
					clearMarkerIcons();
					if (currentInfo) currentInfo.close();
					courtCards.forEach((c) => c.classList.remove('active'));
				});

				google.maps.event.addListener(pin, 'click', (e) => {
					if (e.stopPropagation) {
						e.stopPropagation();
					}
					e.stop();
					clearMarkerIcons();
					pin.setIcon(activeIcon);
					if (currentInfo) {
						currentInfo.close();
					}
					currentInfo = infowindow;
					// Scroll List view & show tooltip
					if (!this.isMobile) {
						scrollWrapper.scrollTo(0, courtCards[i].offsetTop);
					} else {
						courtCards.forEach((c) => c.classList.remove('active'));
						courtCards[i].classList.add('active');
					}
					courtCards[i].focus();

					if (!this.isMobile) {
						infowindow.open({
							anchor: pin,
							currentMap,
							shouldFocus: true
						});
					}
				});
			});
		if (markers[0]) this.map.setCenter(markers[0].getPosition());
		this.map.fitBounds(bounds, 0);

		setTimeout(() => {
			this.map.setOptions(this.options);
		}, 1000);
	}

	multipleSessions() {
		this.hideLoader();
		const resultsList = SelectorEngine.findOne('.js-multiple-sessions');
		const results = SelectorEngine.find('li', resultsList);

		const base = window.location.origin;
		const activeIcon = {
			url: base + '/static/images/simple-pin.png',
			scaledSize: new google.maps.Size(32, 32)
		};

		const markers = [];
		const bounds = new google.maps.LatLngBounds();

		if (results.length > 0) {
			results.forEach((marker, i) => {
				const currentMap = this.map;
				if (
					Manipulator.getDataAttribute(marker, 'latitude') == undefined ||
					Manipulator.getDataAttribute(marker, 'longitude') == undefined
				) {
					return;
				}
				const lat = Number(Manipulator.getDataAttribute(marker, 'latitude')),
					lng = Number(Manipulator.getDataAttribute(marker, 'longitude'));
				const pin = new google.maps.Marker({
					position: new google.maps.LatLng(lat, lng),
					map: this.map,
					optimized: false,
					icon: activeIcon
				});

				markers.push(pin);

				bounds.extend(pin.getPosition());

				const contentString = `<div id="session-content" class="u-body2 u-text-white">${i + 1}</div>`;

				const infowindow = new google.maps.InfoWindow({
					content: contentString,
					maxWidth: 276,
					ariaLabel: `Session ${i} location`
				});

				infowindow.open({
					anchor: pin,
					currentMap,
					shouldFocus: false
				});
			});

			//if (markers[0]) this.map.setCenter(markers[0].getPosition());
			// To do: fix the zoom issue here after fitBounds
			this.map.setZoom(15);
			this.map.fitBounds(bounds);

			this.map.setOptions({
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false
			});
		}
	}

	hideLoader() {
		this.parent.classList.remove('lta-loader');
	}

	createMap() {
		this.map = new window.google.maps.Map(this.mapWrapper, {
			zoom: 10,
			center: { lat: parseFloat(this.position.latitude), lng: parseFloat(this.position.longitude) },
			strictBounds: false
		});
	}

	expandHandler() {
		let trigger = SelectorEngine.findOne('.js-lta-map-expand a', this.card);
		let cardWrapper = SelectorEngine.findOne('.lta-card-container', this.card);

		EventHandler.on(trigger, 'click', (e) => {
			let self = e.target;
			e.preventDefault();
			let dummies = SelectorEngine.find('.lta-card--multiple__dummy.u-hidden', cardWrapper);
			dummies.forEach((e) => {
				e.classList.remove('u-hidden');
			});
			self.parentNode.classList.add('u-hidden');
		});
	}
}

export default Map;
